/* Crunch-Sound auf den Produktkarten (Inhaber 22.10.2026).
   Ein gemeinsamer Player fuer die ganze Seite: ein Tipp spielt, ein zweiter stoppt,
   ein anderer Lautsprecher loest den laufenden ab. Klick geht nicht an den Kartenlink. */
(function () {
  if (window.__melfKarteSound) return;
  window.__melfKarteSound = true;
  var audio = null, aktiv = null;
  function stop() {
    if (audio) { audio.pause(); audio.currentTime = 0; }
    if (aktiv) aktiv.classList.remove('is-spielt');
    aktiv = null;
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('.melf-karte-sound');
    if (!k) return;
    e.preventDefault();
    e.stopPropagation();
    if (aktiv === k) { stop(); return; }
    stop();
    audio = new Audio(k.dataset.src);
    aktiv = k;
    k.classList.add('is-spielt');
    audio.addEventListener('ended', function () { if (aktiv === k) stop(); });
    var p = audio.play();
    if (p && p.catch) p.catch(stop);
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('melf_crunch_sound', { handle: k.dataset.handle, ort: 'karte' });
      }
    } catch (err) {}
  }, true);
})();
